// useShowToggleDetails.ts
import { useMemo } from "react";
import { SHOW_TOGGLE_DETAILS } from "../services/config";

type ShowToggleDetailsKey = keyof typeof SHOW_TOGGLE_DETAILS;

export const useShowToggleDetails = (analysisContextResult: any) => {
  const category = analysisContextResult?.ruleset?.[0]?.category as string | undefined;

  const allowedValues = useMemo(() => {
    if (!category || !(category in SHOW_TOGGLE_DETAILS)) return [];
    return SHOW_TOGGLE_DETAILS[category as ShowToggleDetailsKey];
  }, [category]);

  const shouldShow = (valueToCheck: number): boolean => {
    return !allowedValues.includes(valueToCheck);
  };

  const buildRegex = () => {
    if (!allowedValues.length) return null;
    return new RegExp(
      `(##(${allowedValues.join("|")})##\\s*\\*\\*.*?\\*\\*).*`,
      "g"
    );
  };

  return { category, allowedValues, shouldShow, buildRegex };
};
